import { render } from "./intake_portal.html?vue&type=template&id=1899897f&external"
import script from "./intake_portal.js?vue&type=script&lang=js&external"
export * from "./intake_portal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__